import {
	XCircle,
	Check,
	PlayCircle,
	AlertCircle,
	CheckCircle2,
} from 'lucide-react';
import { STATUS_THEME_COLORS } from './SessionDetailModal';
import { cn } from '@/lib/utils';
import { formatSessionTimeRange } from '../utils/calendarLogic';
import { getSessionPatientDisplayName } from '../utils/getSessionPatientDisplayName';

interface DaySessionsModalProps {
	date: Date;
	sessions: Sessions.Session[];
	onSelectSession: (session: Sessions.Session) => void;
}

// Mapeamento de ícones (Aumentados para size={20} para consistência)
const STATUS_ICONS = {
	CANCELLED: <XCircle size={20} />,
	FINISHED: <Check size={20} />,
	STARTED: <PlayCircle size={20} />,
	CREATED: <AlertCircle size={20} />,
	CONFIRMED: <CheckCircle2 size={20} />,
} as Record<Sessions.SessionStatus, JSX.Element>;

// Cores de fundo leves para o círculo do ícone
const ICON_BG_COLORS = {
	CANCELLED: 'bg-red-50',
	FINISHED: 'bg-zinc-100',
	STARTED: 'bg-orange-50',
	CREATED: 'bg-amber-50',
	CONFIRMED: 'bg-emerald-50',
} as Record<Sessions.SessionStatus, string>;

export const DaySessionsModal = ({
	date,
	sessions,
	onSelectSession,
}: DaySessionsModalProps) => {
	const formattedDate = date.toLocaleDateString('pt-BR', {
		day: 'numeric',
		month: 'long',
		year: 'numeric',
	});

	return (
		<div className="min-w-[280px] antialiased md:min-w-[340px]">
			<p className="mb-2 border-b border-zinc-100 pb-2 text-sm font-medium capitalize text-zinc-500">
				{formattedDate}
			</p>

			<div className="custom-scrollbar max-h-[min(400px,50vh)] space-y-2 overflow-y-auto pr-1">
				{sessions.map((session) => {
					// Puxa as classes de cores do arquivo principal
					const themeClasses =
						STATUS_THEME_COLORS[session.status].split(' ');
					const textColor = themeClasses[1]; // Pega a cor do texto (ex: text-amber-600)
					const bgColor = ICON_BG_COLORS[session.status];
					const sessionIcon = STATUS_ICONS[session.status];
					return (
						<div
							key={session.id}
							onClick={() => onSelectSession(session)}
							className="group flex cursor-pointer items-center gap-4 rounded-xl border border-zinc-100 p-3 transition-all hover:border-zinc-200 hover:bg-zinc-50"
						>
							{/* Ícone dentro de um círculo */}
							<div
								className={cn(
									'flex h-11 w-11 shrink-0 items-center justify-center rounded-full transition-transform group-hover:scale-105',
									bgColor,
									textColor,
								)}
							>
								{sessionIcon}
							</div>

							<div className="flex-1 overflow-hidden">
								<p className="truncate text-[15px] font-bold leading-tight text-zinc-800">
									{getSessionPatientDisplayName(session)}
								</p>
								<p className="mt-1 text-sm font-normal text-zinc-400">
									{formatSessionTimeRange(
										session.selected_date,
									)}
								</p>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};
